import { lazy } from 'react';

import { InAppNotificationsProvider } from '@/components/App/InAppNotificationsProvider';
import { useIndexHtmlChecker } from '@/hooks/appLoading';

const AppRoutes = lazy(() => import('@/components/App/AppRoutes'));
const AppBreadcrumbs = lazy(() => import('@/components/App/AppBreadcrumbs'));
const DeleteConfirmationModals = lazy(() => import('@/components/App/DeleteConfirmationModals'));
const Modals = lazy(() => import('@/components/App/Modals'));

export const AppGateway = () => {
  useIndexHtmlChecker();

  return (
    <InAppNotificationsProvider>
      <Modals>
        <DeleteConfirmationModals>
          <AppBreadcrumbs>
            <AppRoutes />
          </AppBreadcrumbs>
        </DeleteConfirmationModals>
      </Modals>
    </InAppNotificationsProvider>
  );
};
